(() => {
  'use strict';
  if (!customElements.get('ef-drink-mode')) {
    customElements.define('ef-drink-mode', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const buttons = [...this.querySelectorAll('[data-ef-mode]')];
        const show = mode => {
          this.dataset.mode = mode;
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.efMode === mode)));
          this.querySelectorAll('[data-ef-panel]').forEach(panel => panel.setAttribute('aria-hidden', String(panel.dataset.efPanel !== mode)));
          this.querySelectorAll('[data-ef-description]').forEach(copy => { copy.hidden = copy.dataset.efDescription !== mode; });
        };
        buttons.forEach((button, index) => {
          button.addEventListener('click', () => show(button.dataset.efMode), { signal: this.controller.signal });
          button.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + 1) % buttons.length;
            show(buttons[next].dataset.efMode);
            buttons[next].focus();
          }, { signal: this.controller.signal });
        });
        this.classList.add('is-enhanced');
        this.preloadObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.querySelectorAll('.ef-mode__photo').forEach(image => { image.loading = 'eager'; });
          this.preloadObserver.disconnect();
        }, { rootMargin: '400px' });
        this.preloadObserver.observe(this);
        this.querySelector('.ef-mode__controls').hidden = false;
        this.querySelector('[data-ef-mode-hint]').hidden = false;
        show(this.dataset.mode || 'tube');
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.preloadObserver?.disconnect(); }
    });
  }
  if (!customElements.get('ef-buy-bar')) {
    customElements.define('ef-buy-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const root = this.closest('[data-ef-product]');
        const native = root?.querySelector('.product-form__submit');
        const button = this.querySelector('button');
        if (!native || !button) return;
        this.controller = new AbortController();
        const sync = () => {
          button.disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
          button.textContent = native.textContent.trim();
          this.querySelector('[data-ef-sticky-price]').textContent = (root.querySelector('.price-item--sale') || root.querySelector('.price-item--regular'))?.textContent.trim() || '';
        };
        const syncVisibility = () => {
          const visible = native.getBoundingClientRect().bottom < 0;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
        };
        this.observer = new IntersectionObserver(syncVisibility, { threshold: 0.1 });
        this.observer.observe(native);
        window.addEventListener('scroll', syncVisibility, { passive: true, signal: this.controller.signal });
        this.mutation = new MutationObserver(sync);
        this.mutation.observe(native, { attributes: true, childList: true, subtree: true });
        button.addEventListener('click', () => { if (!native.disabled) native.click(); }, { signal: this.controller.signal });
        sync();
        syncVisibility();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); this.mutation?.disconnect(); }
    });
  }
})();
